
import moment from 'moment';
import { Button } from 'primereact/button';
import React, { useContext, useRef, useState } from 'react';
import ReactToPrint from 'react-to-print';
import count_days from '../../functions/count_days';
import sum_total_paid from '../../functions/sum_total_paid';
import sum_total_price from '../../functions/sum_total_price';
import view_apartment_type_ar from '../../functions/view_apartment_type';
import view_day_ar from '../../functions/view_day_ar';

import { RESORT_NAME_AR, RESORT_NAME_EN } from '../../Helper/user';
import { View_date_create } from '../../constants/dataView';
import { sum_discount_value } from '../../functions/fun_sum';
import FooterInvoice from './FooterInvoice';
import HeaderInvoice from './HeaderInvoice';
import { InvoiceContext } from './Invoice_Context';
import './invoice.css';

function InvoiceBookingesReport({ showTotalPaymentTypes = false, paymentSummary = {} }) {
    const data = useContext(InvoiceContext)
    const componentRef = useRef();
    const buttonRef = useRef();
    // eslint-disable-next-line no-unused-vars
    const [isShown, setIsShown] = useState(false);
    var monthView = 0;
    const datasort = [...data.reservations].sort((a, b) =>
        a.date_check_in > b.date_check_in ? 1 : -1,
    );

    return (
        <div>
            <div id="invoice" className="page page-content fade-in-up" dir="rtl" style={{ margin: "auto", maxWidth: "90%" }} ref={componentRef}>
                <div className="ibox invoice-print" >
                    <div className="invoice-header">
                        <div className="row">
                            <div className="col-12">
                                <HeaderInvoice ></HeaderInvoice>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table className="table table-bordered table-striped no-margin table-invoice">
                            <tbody style={{ fontSize: "13px" }}>
                                <tr className="color-view bg-white ">
                                    <td colSpan={3} >
                                        <center>
                                            <strong >
                                                عدد الحجوزات :  {datasort.length}
                                            </strong>
                                        </center>
                                    </td>
                                    <td colSpan={3} >
                                        <center>
                                            <strong >
                                                إجمالي الأيام : {count_days(datasort)}
                                            </strong>
                                        </center>
                                    </td>
                                </tr>
                                {
                                    datasort.map((res) => {
                                        return (
                                            <>
                                                {
                                                    monthView !== moment(res.date_check_in).format('MM') ?
                                                        (
                                                            <>
                                                                <tr className="color-view bg-white ">
                                                                    <td colSpan={14} >
                                                                        <center>
                                                                            <strong >
                                                                                {" حجوزات شهر "}
                                                                                {monthView = moment(res.date_check_in).format('MM')}
                                                                                {" " + moment(res.date_check_in).format('MMMM') + " "}
                                                                            </strong>
                                                                        </center>
                                                                    </td>
                                                                </tr>
                                                                <tr style={{ fontSize: "10px" }}>
                                                                    {data.data_show.ID_reservation ? <th>الحجز</th> : null}
                                                                    {data.data_show.visitor_name || data.data_show.phone_number ? <th> العميل</th> : null}
                                                                    {data.data_show.ID_apartment ? <th>الاقامة</th> : null}
                                                                    {data.data_show.date_check_in ? <th colSpan={2} style={{ textAlign: "center", width: "20%" }} >
                                                                        الاستلام - المغادرة
                                                                    </th> : null}
                                                                    {data.data_show.days ? <th>الأيام</th> : null}
                                                                    {data.data_show.price_day ? <th>سعر اليوم</th> : null}
                                                                    {data.data_show.total_price ? <th>الإجمالي</th> : null}
                                                                    {data.data_show.total_paid ? <th>المدفوع</th> : null}
                                                                    {data.data_show.rest ? <th>الباقي</th> : null}
                                                                    {data.data_show.discount_value ? <th>التخفيض</th> : null}
                                                                    {data.data_show.notes ? <th>ملاحظات</th> : null}
                                                                    {data.data_show.date_create ? <th>وقت الحجز</th> : null}
                                                                    {data.data_show.username ? <th>الحجز عن طريق</th> : null}
                                                                </tr>
                                                            </>
                                                        )
                                                        :
                                                        (null)
                                                }

                                                <tr>
                                                    {data.data_show.ID_reservation ?
                                                        <td>
                                                            {res.ID_reservation}
                                                        </td>
                                                        : null
                                                    }

                                                    {data.data_show.visitor_name || data.data_show.phone_number ?
                                                        <td>
                                                            {data.data_show.visitor_name ?
                                                                <div>
                                                                    <strong >{res.visitor_name}</strong>
                                                                </div>
                                                                : null
                                                            }
                                                            {data.data_show.phone_number ? <small>{res.phone_number}</small> : null}
                                                        </td>
                                                        : null
                                                    }
                                                    {
                                                        data.data_show.ID_apartment ?
                                                            <td>
                                                                <div>
                                                                    <small>{view_apartment_type_ar(res)}</small><strong>{"-" + res.number}</strong>
                                                                </div>
                                                                <small>{res.number_people} أشخاص </small>
                                                            </td>
                                                            : null
                                                    }
                                                    {
                                                        data.data_show.date_check_in ?
                                                            <>
                                                                <td  >
                                                                    <div>
                                                                        <strong >{res.date_check_in} </strong>
                                                                    </div>
                                                                    <small> {view_day_ar(res.date_check_in)} </small>
                                                                </td>
                                                                <td >
                                                                    <div>
                                                                        <strong>{res.date_check_out}  </strong>
                                                                    </div>
                                                                    <small>  {view_day_ar(res.date_check_out)} </small>
                                                                </td>
                                                            </>
                                                            : null
                                                    }
                                                    {
                                                        data.data_show.days ?
                                                            <td style={{ width: "5s%" }}>{count_days([res])} أيام</td> : null
                                                    }
                                                    {
                                                        data.data_show.price_day ?
                                                            <td>{res.price_day}  د.ل</td> : null
                                                    }
                                                    {
                                                        data.data_show.total_price ?
                                                            <td><strong >{res.total_price} د.ل</strong></td> : null
                                                    }
                                                    {
                                                        data.data_show.total_paid ?
                                                            <td><strong >{res.total_paid} د.ل</strong></td> : null
                                                    }
                                                    {
                                                        data.data_show.rest ?
                                                            <td>
                                                                {
                                                                    res.total_price - res.total_paid === 0 ?
                                                                        (
                                                                            <strong style={{ color: "green" }}>
                                                                                مدفوع
                                                                            </strong>
                                                                        )
                                                                        :
                                                                        (
                                                                            <strong style={{ color: "red" }}>
                                                                                {res.total_price - res.total_paid} د.ل
                                                                            </strong>
                                                                        )
                                                                }
                                                            </td> : null
                                                    }
                                                    {
                                                        data.data_show.discount_value ?
                                                            <td><strong >{res.discount_value === 0 ? '-' : res.discount_value + ' د.ل'}</strong></td> : null
                                                    }
                                                    {
                                                        data.data_show.notes ?
                                                            <td style={{ maxWidth: "100px" }}><strong >{res.notes}</strong></td> : null
                                                    }
                                                    {
                                                        data.data_show.date_create ?
                                                            <td><strong >{View_date_create(res)}</strong></td> : null
                                                    }
                                                    {
                                                        data.data_show.username ?
                                                            <td><strong >{res.name}</strong></td> : null
                                                    }
                                                    {/* <td >
                                            {
                                                res.date_del_reservation?
                                                <strong style={{color:"red"}}>
                                                    {moment(res.date_del_reservation).format('MM-DD')}
                                                    <br></br>
                                                    {moment(res.date_del_reservation).format('LT')}
                                                </strong>
                                                :"-"
                                            }
                                        </td> */}
                                                    {/* <td><strong >{res.notes}</strong></td> */}

                                                </tr>

                                            </>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <table className="table  table-bordered table-striped no-margin table-invoice">
                        <thead>
                            <tr>
                                {
                                    data.data_show.footer_total_price ?
                                        <td className="font-bold font-18 text-center bg-white">إجمالي المبلغ  </td> : null
                                }
                                {
                                    data.data_show.footer_total_paid ?
                                        <td className="font-bold font-18 text-center bg-white">إجمالي المدفوع  </td> : null
                                }
                                {
                                    data.data_show.footer_total_rest ?
                                        <td className="font-bold font-18 text-center bg-white">إجمالي المتبقي  </td> : null
                                }
                                {
                                    data.data_show.footer_total_rest ?
                                        <td className="font-bold font-18 text-center bg-white">إجمالي التخفيض  </td> : null
                                }

                            </tr>

                        </thead>
                        <tbody >
                            <tr  >
                                {
                                    data.data_show.footer_total_price ?
                                        <td className="font-bold font-18 text-center bg-white " style={{ padding: "10px" }}>{sum_total_price(data.reservations)} د.ل</td>
                                        : null
                                }
                                {
                                    data.data_show.footer_total_paid ? <td className="font-bold font-18 text-center bg-white" style={{ padding: "10px" }}>{sum_total_paid(data.reservations)} د.ل</td> : null
                                }
                                {
                                    data.data_show.footer_total_rest ?
                                        <td className="font-bold font-18 text-center bg-white" style={{ padding: "10px" }}>
                                            {
                                                sum_total_price(data.reservations) - sum_total_paid(data.reservations) === 0 ?
                                                    (
                                                        <strong style={{ color: "green" }}>
                                                            مدفوع
                                                        </strong>
                                                    )
                                                    :
                                                    (
                                                        <strong style={{ color: "red" }}>
                                                            {sum_total_price(data.reservations) - sum_total_paid(data.reservations)} د.ل
                                                        </strong>
                                                    )
                                            }
                                        </td>
                                        : null
                                }
                                {
                                    data.data_show.footer_total_paid ? <td className="font-bold font-18 text-center bg-white" style={{ padding: "10px" }}>{sum_discount_value(data.reservations)} د.ل</td> : null
                                }
                            </tr>
                        </tbody>

                    </table>
                    {showTotalPaymentTypes ?
                        <table className="table table-bordered table-striped no-margin" style={{ fontSize: "17px", fontFamily: "Cairo", direction: "rtl" }}>
                            <thead>
                                <tr>
                                    <th style={{ fontSize: "16px" }} colSpan={5}>
                                        <center>
                                            طـــرق الدفــع
                                        </center>
                                    </th>

                                </tr>
                                <tr>
                                    <th style={{ fontSize: "16px" }}>إجمالي الحجوزات</th>
                                    {Object.keys(paymentSummary?.totals).map(type => (
                                        <th key={type} style={{ fontSize: "16px" }}>{type}</th>
                                    ))}
                                    <th style={{ fontSize: "16px" }}>إجمـالي المبلـغ</th>
                                </tr>
                                <tr>
                                    <td style={{ fontWeight: "bold" }}>{data?.reservations?.length}</td>
                                    {Object.keys(paymentSummary?.totals).map(type => (
                                        <td key={type} style={{
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                            color: paymentSummary?.totals[type] < 0 ? "red" : paymentSummary?.totals[type] > 0 ? "green" : undefined
                                        }}>
                                            {Intl.NumberFormat("en-US").format(paymentSummary?.totals[type])} د.ل
                                        </td>
                                    ))}
                                    <td style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        color: paymentSummary?.grandTotal > 0 ? "green" : paymentSummary?.grandTotal < 0 ? "red" : undefined
                                    }}>
                                        {Intl.NumberFormat("en-US").format(paymentSummary?.grandTotal)} د.ل
                                    </td>
                                </tr>
                            </thead>
                        </table>
                        :
                        null
                    }
                    <br></br>
                    <center className='font-bold font-18 text-center' >
                        نتمنى لكم قضاء صيف رائع في {RESORT_NAME_AR} - {RESORT_NAME_EN}
                    </center>
                    <br></br>


                </div>
                <FooterInvoice></FooterInvoice>
            </div>

            <div className="text-center">
                <ReactToPrint
                    trigger={
                        () => <Button dir='ltr' type="button" label=" طبــاعة " icon='fa fa-print' outlined
                            ref={buttonRef} onClick={() => setIsShown(current => !current)}
                        />
                    }
                    content={() => componentRef.current}
                />
            </div>
        </div>
    );
}
export default InvoiceBookingesReport;